import { useState, useCallback } from 'react';
import { ReactFlow, applyNodeChanges, applyEdgeChanges, addEdge, type NodeChange, type EdgeChange, type EdgeTypes, Controls, MiniMap, Background, BackgroundVariant, type NodeProps } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { Asset3DPreview } from '../preview';
 
type SampleNodeType = { id: string; position: { x: number; y: number; }; data: { label: string; assetId: string }; type:string };

type SampleNodeEdge = { id: string; source: string; target: string; };



type SceneGraphEditorProps = {
  assetId: string;
};

function Asset3DPreviewNode(props: { data: { assetId: string | undefined; }; }) {
  return (
    <div style={{ width: 1024, height: 1024, border: '1px solid black' }}>
      <Asset3DPreview
        assetId={props.data.assetId}
      />
     </div>
  )
}

const nodeTypes = {previewer3D: Asset3DPreviewNode};
export function SceneGraphEditor({ assetId }: SceneGraphEditorProps) {

  const initialNodes:SampleNodeType[] = [
    { id: 'n1', position: { x: 0, y: 0 }, data: { label: assetId, assetId }, type: 'previewer3D' },
  ];

  const initialEdges:SampleNodeEdge[] = [];

  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);
 
  const onNodesChange = useCallback(
    (changes: NodeChange<SampleNodeType>[]) => setNodes((nodesSnapshot) => applyNodeChanges(changes, nodesSnapshot)),
    [],
  );
  const onEdgesChange = useCallback(
    (changes: EdgeChange<SampleNodeEdge>[]) => setEdges((edgesSnapshot) => applyEdgeChanges(changes, edgesSnapshot)),
    [],
  );
  const onConnect = useCallback(
    (params: any) => setEdges((edgesSnapshot) => addEdge(params, edgesSnapshot)),
    [],
  );
 
  return (
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        nodeTypes={nodeTypes}
      >
        <Controls />
        <MiniMap />
        <Background variant={BackgroundVariant.Dots} gap={12} size={1} />
      </ReactFlow>
  );
}